import React from 'react'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import StyledXsText from '../../../common/components/styledXsText/StyledXsText'
import { Link } from 'react-router-dom'
import { content } from '../../../data'

const Footer = () => {

  const currentYear = new Date().getFullYear();
  const menuItems = content?.menuItems;

  return (
    <div className='flex flex-col w-full items-center bg-dull-black rounded-tl-[48px] rounded-tr-[48px] border-t-white border-x-white border-opacity-20 border'>
      <div className='w-[90%] py-10 flex md:flex-row flex-col gap-10 md:gap-0 items-center justify-between border-b-[1px] border-white border-opacity-20'>
        <Link to="/" className='flex gap-3 cursor-pointer md:w-[30%] justify-start'>
          <div>
            <img width={50} height={50} src='/assets/images/logo.webp' alt='Logo' />
          </div>
          <div className='flex items-center'>
            <StyledMdText fontColor="text-gradient">HopeLedger</StyledMdText>
          </div>
        </Link>
        <div className='hidden md:flex gap-10 md:w-[40%] justify-center'>
          {
            menuItems?.map((item, index) => (
              <Link to={item?.link} key={index} className='text-white'>{item?.menu}</Link>
            ))
          }
        </div>
        <div className='flex gap-5 md:w-[30%] justify-end'>
          <div className='flex items-center'>
            <img src='/assets/images/discord.webp' alt='Discord' />
          </div>
          <div className='flex items-center'>
            <img src='/assets/images/twitter.webp' alt='Twitter' />
          </div>
        </div>
      </div>
      <div className='flex py-5 text-center'>
        <StyledXsText fontColor="text-white">Copyright &#169; {currentYear} Hope<b>Ledger.</b> All Rights Reserved.</StyledXsText>
      </div>
    </div>
  )
}

export default Footer
